export const SPINNER_SET = 'SPINNER_SET';
export const SPINNER_UNSET = 'SPINNER_UNSET';

export const SHOW_LITERACY_MODAL = 'SHOW_LITERACY_MODAL';
export const HIDE_LITERACY_MODAL = 'HIDE_LITERACY_MODAL';
export const SET_LITERACY_RESULT = 'SET_LITERACY_RESULT';

export const USER_LOGIN = 'USER_LOGIN';
export const USER_LOGOUT = 'USER_LOGOUT';
export const USER_SIGNUP = 'USER_SIGNUP';
export const USER_LOGIN_ERROR = 'USER_LOGIN_ERROR';
export const USER_SIGNUP_ERROR = 'USER_SIGNUP_ERROR';
export const SET_ROOT_LINK = 'SET_ROOT_LINK';

export const GET_UNITS = 'GET_UNITS';
export const GET_UNIT_STATS = 'GET_UNIT_STATS';
export const DELETE_UNIT = 'DELETE_UNIT';
export const GET_SCHOLAR_DATA = 'GET_SCHOLAR_DATA';
export const SET_ACTIVE_SCHOLAR = 'SET_ACTIVE_SCHOLAR';
export const SET_MERGE_ERROR = 'SET_MERGE_ERROR';
export const RESET_SCHOLARS_DATA = 'RESET_SCHOLARS_DATA';
export const CREATE_SCHOLAR_ERROR = 'CREATE_SCHOLAR_ERROR';
export const CREATE_ANETAPACK_ERROR = 'CREATE_ANETAPACK_ERROR';

export const GET_USER_DATA = 'GET_USER_DATA';
export const RESET_USER_DATA = 'RESET_USER_DATA';
export const UPDATE_USER_ERROR = 'UPDATE_USER_ERROR';

export const GET_EVENTS = 'GET_EVENTS';
export const CREATE_EVENT = 'CREATE_EVENT';
export const GET_EVENT_ERRORS = 'GET_EVENT_ERRORS';
export const DELETE_EVENT = 'DELETE_EVENT';
export const GET_MERGE_EVENTS = 'GET_MERGE_EVENTS';
export const SET_EVENT_VISITED = 'SET_EVENT_VISITED';

export const GET_DRESOURCES = 'GET_DRESOURCES';
export const CREATE_DRESOURCES = 'CREATE_DRESOURCES';
export const DELETE_DRESOURCE = 'DELETE_DRESOURCE';
export const EDIT_DRESOURCE = 'EDIT_DRESOURCE';

export const OFFLINE_SPINNER_ON = 'OFFLINE_SPINNER_ON';
export const OFFLINE_SPINNER_OFF = 'OFFLINE_SPINNER_OFF';

export const GLOBAL_ERR = 'GLOBAL_ERR';
export const CLEAR_GLOBAL_ERR = 'CLEAR_GLOBAL_ERR';
export const RESET_GLOBL_STATE = 'RESET_GLOBL_STATE';

export const GET_SIGNIN_RESOURCES = 'GET_SIGNIN_RESOURCES';
export const CREATE_SIGNIN_RESOURCES = 'CREATE_SIGNIN_RESOURCES';
export const DELETE_SIGNIN_RESOURCE = 'DELETE_SIGNIN_RESOURCE';
export const EDIT_SIGNIN_RESOURCE = 'EDIT_SIGNIN_RESOURCE';

export const GET_ANETA_PACKS = 'GET_ANETA_PACKS';
export const GET_CURRENT_ANETA_PACK = 'GET_CURRENT_ANETA_PACK';
export const SET_ANETAPACK_ERROR = 'SET_ANETAPACK_ERROR';
export const CHANGE_AP_OPTIONS = 'CHANGE_AP_OPTIONS';

export const GET_AVAILABLE_PLANS = 'PAYMENTS/GET_AVAILABLE_PLANS';
export const CREATE_SUBSCRIPTION = 'PAYMENTS/CREATE_SUBSCRIPTION';
export const GET_AVAILABLE_CARDS = 'PAYMENTS/GET_AVAILABLE_CARDS';
export const SET_REFFERALS_ERRORS = 'SET_REFFERALS_ERRORS';
export const SET_USER_REFERRAL_INFO = 'SET_USER_REFERRAL_INFO';
export const SET_USER_DEFAULT_PAYMENT_METHOD =
  'PAYMENTS/SET_USER_DEFAULT_PAYMENT_METHOD';
